import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { Suspense } from "react";
import { Center, Loader } from "@mantine/core";
import { RootNotFound } from "./components/RootNotFound";
import { FlareErrorBoundary } from "./components/FlareErrorBoundary";

export const rootRoute = createRootRoute({
  component: () => (
    <>
      <FlareErrorBoundary>
        <Suspense
          fallback={
            <Center h="100dvh">
              <Loader />
            </Center>
          }
        >
          <Outlet />
        </Suspense>
        {import.meta.env.MODE === "development" && <TanStackRouterDevtools />}
      </FlareErrorBoundary>
    </>
  ),
  notFoundComponent: RootNotFound,
});
